class SubCollection extends HTMLElement {
  constructor(){
    super();

    const stateLocalStorageKey = `modal-${document.location.hostname}-modal-state-selector`;
    const stateStorage = localStorage.getItem(stateLocalStorageKey) ? JSON.parse(localStorage.getItem(stateLocalStorageKey)) : null;

    this.currentState = stateStorage ? stateStorage.state : null;
    this.navigations = window.theme.settings.navigations ?? {};

    this.breadcrumbs = [];
  }

  connectedCallback() {
    if (Object.keys(this.navigations).length === 0 || !this.currentState) {
      return
    }

    let navigation = this.navigations[this.currentState];

    // Use default nav if state navigation is emtpy
    if (navigation.length === 0 && !document.location.href.includes('jm-')) {
      navigation = this.navigations['DEFAULT'];
    } else if (document.location.href.includes('jm-')) {
      navigation = this.navigations['JMNPL'];
    }

    const location = window.location.href;
    let links;

    for (const parent of navigation) {
      if (parent.active && location.includes(parent.url)) {
        links = parent.links;
        this.pushBreadcrumbs(parent.url, parent.title);
        break;
      }

      console.log(parent)

      if (parent.child_active) {
        console.log(123)
        let child = parent.links.find((o) => o.active && location.includes(o.url));
        if (child) {
          links = child.links;
          if(child.active) {
            this.pushBreadcrumbs(parent.url, parent.title);
            this.pushBreadcrumbs(child.url, child.title);
            break;
          }
        } else {
          child = parent.links.find((o) => o.child_active);
          if(child) {
            const grandchild = child.links.find((o) => o.active && location.includes(o.url));
            if(grandchild) {
              links = grandchild.links;
              this.pushBreadcrumbs(parent.url, parent.title);
              this.pushBreadcrumbs(child.url, child.title);
              this.pushBreadcrumbs(grandchild.url, grandchild.title);
              break;
            } else {
              grandchild = child.links.find((o) => o.links.some((c) => location.includes(c.url)));
              if(grandchild) {
                const childCollection = grandchild.links.find((o) => location.includes(o.url));
                if (childCollection) {
                  this.pushBreadcrumbs(parent.url, parent.title);
                  this.pushBreadcrumbs(child.url, child.title);
                  this.pushBreadcrumbs(grandchild.url, grandchild.title);
                  this.pushBreadcrumbs(childCollection.url, childCollection.title);
                }
              }
            }
          }
          break;
        }
      }

    }

    // Start handle 4 levels of nesting in the menu
    if(this.breadcrumbs.length == 0) {
      let findingMenuLevel4 = false;
      for (const parent of navigation) {
        for(const child of parent.links) {
          for(const grandchild of child.links) {
            for(const collectionChild of grandchild.links) {
              if(collectionChild.active) {
                console.log("collection child: ", collectionChild);
                this.pushBreadcrumbs(parent.url, parent.title);
                this.pushBreadcrumbs(child.url, child.title);
                this.pushBreadcrumbs(grandchild.url, grandchild.title);
                this.pushBreadcrumbs(collectionChild.url, collectionChild.title);
                findingMenuLevel4 = true;
              }
            }
            if(findingMenuLevel4) break;
          }
          if(findingMenuLevel4) break;
        }
        if(findingMenuLevel4) break;
      }
      // If current collection not in all menu level 3 then show breadcrumb like Home / Current Collection
      if(findingMenuLevel4 == false) {
        const currentCollection = JSON.parse(this.dataset.options).current_collection;
        this.pushBreadcrumbs(currentCollection.handle, currentCollection.title);
      }
    }
    // End handle 4 levels of nesting in the menu

    this.renderElements(links, this.breadcrumbs);
  }

  pushBreadcrumbs(url, title) {
    const breadcrumbObj = {
      "url": url,
      "title": title
    }
    this.breadcrumbs.push(breadcrumbObj);
  }

  renderElements(links, breadcrumbs) {

    const div = document.createElement('div');
    let breadcrumbNav = '';
    let slider = '';
    if(links) {
      slider = `<css-slider class="css-slider css-slider--middle-navigation css-slider--hide-dots css-slider--hide-indexnav" data-options='${this.dataset.options}'>
        <div class="grid grid--slider">
          ${
            links.map(({ url, title, image }) => `
              <div class="card js-collection-item text-align--center">
                <a class="card__whole-link" href="${url}" title="${title}">
                  <div class="card__image border-radius-top" style="padding-top: 100%">
                    <figure class="lazy-image lazy-image--animation lazy-image--background lazyloaded" data-ratio="1" style="padding-top: 100%" data-crop="false">
                      <img src="${image}&amp;width=360" alt="${title}" class="img" width="360" height="360" data-ratio="1" loading="eager" onload="this.parentNode.classList.add('lazyloaded')" data-arkhi-grid-productmedia>
                    </figure>
                  </div>
                  <div class="card__text gutter--small spacing--xsmall remove-empty-space">
                    <span>${title}</span>
                  </div>
                </a>
              </div>
            `).join('')
          }
        </div>
      </css-slider>`;
    }
    breadcrumbNav = `<div class="breadcrumb-main">
      <div class="breadcrumb-container">
      <nav class="breadcrumb" role="navigation" aria-label="breadcrumbs">
      <span class="breadcrumb__link"><a href="/">Home</a></span>
      <span class="breadcrumb__separator">/</span>
    `;
    
    if(breadcrumbs) {
      breadcrumbNav += `
        ${
          breadcrumbs.map(({ url, title }) => `
          <span class="breadcrumb__link"><a href="${url}">${title}</a></span>
          <span class="breadcrumb__separator">/</span>
          `).join('')
        }`
      ;
    }
    breadcrumbNav += `
        </div>
      </div>
    `;

    div.innerHTML = `
      ${breadcrumbNav}
      ${slider}
    `;

    this.appendChild(div);
  }
}
if (!customElements.get('sub-collection')){
  customElements.define('sub-collection', SubCollection);
}